export default __webpack_public_path__ + "static/media/comp1.1a7e5a79.png";